<script setup lang="ts">
import GpcoreIcon from 'gpcore-uikit/icons/mono/gpcore.vue';
import WelcomeSection from './shared/WelcomeSection.vue';
import ContinueButton from './shared/ContinueButton.vue';

const emit = defineEmits<{
  nextButtonClicked: [];
}>();
</script>

<template>
  <WelcomeSection name="Introduction" :is-done="true" v-playwright="'welcome-intro-section'">
    <template #content>
      <div class="tw-text-center">
        <GpcoreIcon class="tw-mx-auto tw-mb-4 tw-size-24 tw-text-gp-cyan" />
        <h2 class="tw-mt-4 tw-text-4xl tw-font-bold">Welcome to GPCORE Panel</h2>
        <p class="tw-mt-4">
          Great to have you here! To fully profit from our services, it is essential to complete the
          onboarding process. The guided setup will make sure you are ready to start using GPCORE.
        </p>
      </div>
    </template>

    <template #footer>
      <ContinueButton
        class="tw-mx-auto"
        label="Get started"
        @click="emit('nextButtonClicked')"
        v-playwright="'welcome-intro-btn'"
      />
    </template>
  </WelcomeSection>
</template>

<style scoped></style>
